<script lang="ts" setup>
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import {parseQtnr} from '@/script/nft/nftQtnrScript';
import MvModal from '@/components/common/modal/MvModal.vue';
import {useModal} from '@/script/common/modalScript';
import NftQtnrModifyModal from '@/components/common/modal/nft/NftQtnrModifyModal.vue';

const props = defineProps({
  qtnrInfo: {
    default: {}
  },
  qtnrTemplate: {
    default: []
  }
})

const { t } = useI18n()

const qtnrList = computed(() => {
  return props.qtnrTemplate.map(qtnr => {
    const keyInfo = parseQtnr(qtnr ,t)
    return {
      label: keyInfo.name,
      value: props.qtnrInfo[qtnr.name],
    }
  })
})

const {
  isOpen,
  toggleModal,
} = useModal()

</script>

<template>
  <div>
    <div class="nft-card-info-item-section mb-16">
      <div class="nft-card-info-item">
        <div>
          <div class="nft-card-info-title mb-12">
            {{ $t("nftCard.precaution.qtnr.title") }}
          </div>
          <div class="nft-card-info-content">
            <div
                v-for="(qtnr, index) in qtnrList"
                :key="index"
                class="info-row"
            >
              <div class="info-col">
                {{ qtnr.label }}
              </div>
              <div class="nft-card-info-content">
                <div>{{ qtnr.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="extra-row">
      <div class="col-text">{{ $t('nftCard.precaution.qtnr.modifyAsk') }}</div>
      <div class="val-text" @click="toggleModal(true)">{{ $t('nftCard.precaution.qtnr.modifyReq') }}</div>
    </div>
    <MvModal
        v-model:visible="isOpen"
    >
      <template #content>
        <NftQtnrModifyModal @confirm="toggleModal(false)"/>
      </template>
    </MvModal>
  </div>
</template>

